/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LiffAccessToken } from '../models/LiffAccessToken';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LiffService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Validate LIFF access token
     * @returns LiffAccessToken OK
     * @throws ApiError
     */
    public validateAccessToken(): CancelablePromise<LiffAccessToken> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/validate-access-token',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
